// extracted by mini-css-extract-plugin
module.exports = {"url":"Docs-module_url_3XOxH","quote":"Docs-module_quote_2kSPA","markdown-section":"Docs-module_markdown-section_3mOwd"};